import clsx from 'clsx';
import { Image, Video } from '~/shared/components';
import styles from './HeroImage.module.scss';
import { VideoMedia } from '~/lib';
import { ReactNode } from 'react';
import { CustomCSSProperties } from '~/templates/blocks/components/M11Hero/M11Hero';

interface HeroImageProps {
    image: {
        id?: number;
        name?: string;
        crops?: any[];
        src: string;
        extension?: string;
        height?: number;
        width?: number;
        ratio?: number;
        type?: string;
    };
    imageAltText?: string;
    watermark: string;
    imageOnBackground: boolean;
    video?: VideoMedia;
    title?: string;
    watermarkElement?: ReactNode;
    customProperties?: CustomCSSProperties;
}

export const HeroImage = ({
    image,
    imageAltText,
    watermark,
    imageOnBackground,
    video,
    title,
    customProperties,
    watermarkElement,
}: HeroImageProps) => {
    return (
        <div className={styles.media} style={customProperties}>
            <div
                className={clsx(styles.mediaWrapper, {
                    [styles.isVerticalOnMobile]: !!video?.src,
                })}
            >
                {imageOnBackground && (
                    <div
                        className={clsx(styles.watermark, {
                            [styles.watermarkPercentMobile]:
                                imageOnBackground && watermark === 'Percent',
                            [styles.watermarkLogoImage]: imageOnBackground && watermark === 'Logo',
                        })}
                    >
                        {watermarkElement}
                    </div>
                )}

                <div className={styles.shadow} />

                {video ? (
                    <div
                        className={clsx(styles.mediaElement, {
                            [styles.imageOnBackground]: imageOnBackground,
                        })}
                    >
                        <Video
                            name={title}
                            muted={video.mute}
                            controls={false}
                            src={video.src}
                            loop={video.loop}
                            playing={video.autoPlay}
                            posterSrc={image?.src}
                            cover={true}
                            theaterMode={video.theaterMode}
                        />
                    </div>
                ) : (
                    <Image
                        src={image.src}
                        alt={imageAltText}
                        className={clsx(styles.mediaElement, {
                            [styles.imageOnBackground]: imageOnBackground,
                        })}
                        layout="fill"
                        objectFit={imageOnBackground ? 'contain' : 'cover'}
                        objectPosition="center"
                    />
                )}
            </div>
        </div>
    );
};
